import { Flex, Image, Text } from "@fluentui/react-northstar";
import React from "react";
import ImgForEmptyTask from "../../../assets/illustrations/offboarding/NoTaskOffboarding.svg";
import styled from "styled-components";

export default function EmptyDetailCollabTasks({ activeTab }) {
    const EmptyTasks = () => {
        switch (activeTab) {
            case 0:
                return (
                    <Flex hAlign="center" gap="gap.small" column>
                        <TextStyle content="Aucune tâche d'offboarding à réaliser par le collaborateur" />
                        <Text content="Lancez l'Offboarding pour lui assigner des tâches." />
                    </Flex>
                );
            case 1:
                return (
                    <Flex hAlign="center" gap="gap.small" column>
                        <TextStyle content="Aucune tâche d'offboarding à réaliser par le collaborateur" />
                    </Flex>
                );
            case 2:
                return "Aucun Processus d'offboarding à archiver";
            default:
                return (
                    <Flex hAlign="center" gap="gap.small" column>
                        <TextStyle content="Aucune tâche d'offboarding à réaliser par le collaborateur" />
                        <Text content="Lancez l'Offboarding pour lui assigner des tâches." />
                    </Flex>
                );
        }
    };
    return (
        <EmptyFlex gap={"gap.medium"} column fill hAlign="center">
            <Image src={ImgForEmptyTask} alt="empty data" />
            <Text content={EmptyTasks(activeTab)} />
        </EmptyFlex>
    );
}

const TextStyle = styled(Text)`
    color: #000;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;

const EmptyFlex = styled(Flex)`
    padding-block: 26px 70px;
`;
